import { NgClass, NgOptimizedImage, NgTemplateOutlet } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    OnInit,
    signal,
    ViewEncapsulation,
    WritableSignal,
} from '@angular/core';
import { RouterLinkWithHref } from '@angular/router';
import { AssetPipe } from '@libraries/asset/asset.pipe';
import { ChipComponent } from '@libraries/chip/chip.component';
import { BorderButtonComponent } from '@shared/border-button/border-button.component';
import { GridComponent } from '@shared/grid/grid.component';
import { HeaderTitleComponent } from '@shared/header-title/header-title.component';
import { AppPath } from '@shared/routes/app-routing.const';
import positionsJson from 'src/assets/json/positions.json';
import { CareerPosition, CareerPositionStyle } from './career-positions.types';
import { CareerPositionsPipe } from './career-positions.pipe';
import { AnchorLabelPipe } from '@libraries/anchor/anchor-label.pipe';

@Component({
    selector: 'jsdaddy-career-positions',
    standalone: true,
    imports: [
        NgTemplateOutlet,
        RouterLinkWithHref,
        AssetPipe,
        CareerPositionsPipe,
        HeaderTitleComponent,
        ChipComponent,
        BorderButtonComponent,
        GridComponent,
        NgOptimizedImage,
        AnchorLabelPipe,
        NgClass,
    ],
    templateUrl: './career-positions.component.html',
    styleUrl: './career-positions.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CareerPositionsComponent implements OnInit {
    public readonly contactUsPath = `/${AppPath.CONTACT_US}`;
    public readonly careerPath = `/${AppPath.CAREER}`;
    public positions: WritableSignal<CareerPositionStyle[]> = signal([]);

    public ngOnInit(): void {
        const positions = positionsJson.reduce(
            (acc: CareerPositionStyle[], obj: CareerPosition, index: number) => {
                // TODO(xakeppok) test with marbles or move reduce cb to separate function
                const prevObj = acc[index - 1];
                const isNewGroup = !prevObj || prevObj.position !== obj.position;
                const styleClass = isNewGroup
                    ? !prevObj || prevObj.styleClass === 'ai-end'
                        ? 'ai-start'
                        : 'ai-end'
                    : prevObj.styleClass;
                return [
                    ...acc,
                    {
                        ...obj,
                        styleClass,
                    },
                ];
            },
            []
        );
        this.positions.set(positions);
    }
}
